import { IconPack } from "Explore/Config/Icons";
import styles from "./HomeHeroSection.module.scss";
import { Container, Grid } from "@mui/material";
import CountUp from "react-countup";
import { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";

const HomeHeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  const formatStatisticNumber = (value) => {
    let _value;
    if (value >= 999999) {
      _value = (value / 1000000).toFixed(1) + "M";
    } else if (value >= 999) {
      _value = (value / 1000).toFixed(1) + "K";
    } else if (value >= 99) {
      _value = Math.floor(value / 50) * 50;
    } else {
      _value = value;
    }

    return _value + "+";
  };
  const statistics = [
    {
      icon: IconPack.institution_outline_black,
      title: "Research Institutions",
      value: 432,
    },
    {
      icon: IconPack.unit_faculty_members,
      title: "Academic Researchers",
      value: 1000001,
    },
    { icon: IconPack.publications, title: "Research Papers", value: 25500001 },
    { icon: IconPack.keyword, title: "Academic Keywords", value: 17001 },
    {
      icon: IconPack.venue_outline_black,
      title: "Publication Venues",
      value: 5501,
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      // Determine when to show the component (e.g., when scrolled 500px down)
      if (
        !!ref.current &&
        window.innerHeight - ref.current.getBoundingClientRect().top >
          window.innerHeight / 10
      ) {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <div className={styles["home-hero-section"]} ref={ref}>
      <p className={styles["home-hero-section--title"]}>
        Explore Academic Research
      </p>
      <Grid
        container
        maxWidth="lg"
        className={styles["home-hero-section--statistics"]}
      >
        {statistics.map(({ icon, title, value }, index) => (
          <Grid
            item
            xs
            key={index}
            className={styles["home-hero-section--statistics--item__container"]}
          >
            <div className={styles["home-hero-section--statistics--item"]}>
              <div
                className={styles["home-hero-section--statistics--item--icon"]}
              >
                {icon}
              </div>
              <div
                className={
                  styles["home-hero-section--statistics--item--content"]
                }
              >
                <p
                  className={
                    styles[
                      "home-hero-section--statistics--item--content--value"
                    ]
                  }
                >
                  {isVisible && (
                    <motion.span
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 2, ease: "easeInOut" }}
                    >
                      <CountUp
                        start={0}
                        end={value}
                        duration={Math.max(3, Math.sqrt(value / 1000000))}
                        formattingFn={formatStatisticNumber}
                        useEasing
                      />
                    </motion.span>
                  )}
                </p>
                <p
                  className={
                    styles[
                      "home-hero-section--statistics--item--content--title"
                    ]
                  }
                >
                  {title}
                </p>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default HomeHeroSection;
